export const generateTokenExpiryInterval = (tokenExp: number) => {
  return tokenExp * 1000 - 180000
}
